import { useBreakpoint } from "@core-ui/hooks/useBreakpoint";
import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { Logo, TopContainerWrapper } from "../../../../components/HomePage/Welcome/Editor";

export const GesCloudSignInHeader = () => {
	const breakpoint = useBreakpoint();

	return (
		<div className="header flex flex-col justify-center items-center text-center p-6 pb-0 gap-3">
			<Logo isMobile={breakpoint === "sm"} />
			<TopContainerWrapper className={cn(breakpoint === "sm" && "mobile")}>
				<h1 className="text-2xl font-semibold sm:text-lg">{t("welcome.editor.title")}</h1>
				<div className="description text-base text-muted sm:text-sm font-normal">
					{t("enterprise-cloud-guest.description")}
				</div>
			</TopContainerWrapper>
		</div>
	);
};
